//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import BuildingService from '@/service/building'

import CommonTabs from '@/components/views/common_tabs'


import Loading from '@/components/views/loading'
import BottomTip from '@/components/views/bottom_tip'

import EventTip from './_tip'
import EventItem from './_item'
import EventFooter from './_footer'

import detailSubPage from '@/common/mixins/detailSubPage'
import pagination from '@/common/mixins/pagination'

import { DEFAULT_PER }  from '@/config'

import like_tip from '../mixins/likeTip'
import LikeTip from '../_components/_like_tip'
import PhoneTip from '../_components/_phone_tip'
import SubscribeSuccess from '../_components/_subscribe_success'
import LocalData from '@/utils/local_data'

export default {
    mixins: [
        pagination,
        detailSubPage,
        like_tip
    ],
    data () {
        return {
            customer_service_info: {},
            tabs: [],
            is_building_consultant: false,
            is_consultant: false,
            building_event_author: false,
            title: '',
            type: '全部',
            house: {},
            building_id: ''
        }
    },
    created () {
        this.getBuilding()
    },
    mounted () {
        this.getData()
    },
    methods: {
        changeFavourite() {
            this.toggleFavourite('楼盘动态页——关注')
            this.getBuilding()
        },
        getBuilding () {
            const { building_id } = this.$route.query
            this.building_id = building_id
            Service.getBuilding(building_id).then((data) => {
                data.favourite = Boolean(data.follow_info && data.follow_info.id)
                this.title = data.name
                this.house = data
            })
        },
        getData () {
            const { building_id } = this.$route.query
            this.loading = true
            LocalData.user.get().then((data) => {
                this.is_consultant = data.is_consultant
            })
            BuildingService.getEvent(building_id, {
                category: this.type,
                page: this.page,
                per: DEFAULT_PER
            }).then(data => {
                this.customer_service_info = data.customer_service_info
                this.handleData(data)
                this.is_building_consultant = data.is_consultant
                this.building_event_author = data.building_event_author

                this.tabs = Object.keys(data.dashboard).map((key) => {
                    const count = data.dashboard[key]
                    return {
                        key,
                        name: count ? `${key}(${count})` : key
                    }
                })
            })
        },
        changeType (type) {
            this.type = type
            this.page = 1
            this.getData()
        }
    },
    components: {
        Loading,
        BottomTip,
        EventTip,
        EventItem,
        EventFooter,
        CommonTabs,
        LikeTip,
        PhoneTip,
        SubscribeSuccess
    }
}
